/** Global SWR config: shared JSON fetcher, dedup and retry policy. */

'use client';

import { SWRConfig } from 'swr';
import { ReactNode } from 'react';

// Exported for tests. Non-string keys (e.g. the ai SDK's array keys with a null
// fetcher) are not URLs: skip them instead of fetching "a,b,c" as a path.
export const globalFetcher = async (url: unknown) => {
  if (typeof url !== 'string') return undefined;
  const res = await fetch(url);

  if (!res.ok) {
    const error = new Error('An error occurred while fetching the data.');
    throw error;
  }

  return res.json();
};

interface SWRProviderProps {
  children: ReactNode;
}

export function SWRProvider({ children }: SWRProviderProps) {
  return (
    <SWRConfig
      value={{
        fetcher: globalFetcher,
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        dedupingInterval: 5000,
        errorRetryCount: 3,
        errorRetryInterval: 5000,
        shouldRetryOnError: true
      }}
    >
      {children}
    </SWRConfig>
  );
}
